<template>
  <li class="mt-[4px] mb-[4px] w-full px-[10px] py-[6px] border border-[#CFCFCF] rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow text-base">
    <h2 class="font-jost-medium text-blue-dark text-base">{{ chain.chainName }} Chain</h2>
    <div class="flex items-center justify-between">    
      <!-- Middle: Chain Details -->
      <div class="flex-1 flex items-center gap-[50px] mr-4 min-w-0">

        <!-- Chain name -->
        <div class="flex items-center gap-2 text-base flex-2">
          <span class="text-[#6B7280]">Chain Name:</span>
          <RouterLink
            v-if="chain.chainNumber !== undefined && chain.chainNumber !== null"
            :to="{ name: 'chain', params: { chainNumber: chain.chainNumber } }"
            class="text-[#374151] font-jost-regular"
            :title="chain.chainName || 'N/A'"
          >
            {{ chain.chainName || 'N/A' }}
          </RouterLink>
          <span v-else class="text-[#374151] font-jost-regular" :title="chain.chainName || 'N/A'">
            {{ chain.chainName || 'N/A' }}
          </span>
        </div>

         <!-- Last blocks -->
        <!-- <div class="flex items-center min-w-0 flex-2">
          <span class="text-[#6B7280] font-medium mr-1 text-base">Last block:</span>
            <router-link
              v-if="chain.chainNumber !== undefined && chain.chainNumber !== null && chain.lastBlocks !== undefined && chain.lastBlocks !== null"
              class="text-blue-dark cursor-pointer text-base"
              :to="{ name: 'block', params: { chainNumber: chain.chainNumber, blockNumber: chain.lastBlocks } }"
            >
              #{{ chain.lastBlocks || 'N/A' }}
            </router-link>
            <span v-else class="text-blue-dark text-base">#{{ chain.lastBlocks || 'N/A' }}</span>
         
        </div>
        <div class="flex items-center gap-4 text-base">
            <div class="text-right min-w-[120px]">
            <span class="text-[#6B7280] font-medium mr-1 text-base">Transaction count:</span>
            <span class="text-[#374151] font-jost-regular text-base" :title="chain.transactionCount">
                {{ chain.transactionCount || 'N/A' }}
            </span>
            </div>
        </div> -->
      </div>
      
    </div>
  </li>
</template>

<script>
import { formatDateTime } from '@/helpers/common';

export default {
  name: 'ChainCard',
  props: {
    chain: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatDateTime(timestamp) {
      return formatDateTime(timestamp);
    },
  }
}
</script>

<style scoped>
/* Component styles are handled by Tailwind classes */
</style>
